export const CURRENCY_SYMBOLS = { TRY: "₺", USD: "$", EUR: "€" };

export function formatMoney(amount, currency = "TRY") {
  const value = Number(amount || 0);
  const symbol = CURRENCY_SYMBOLS[currency] || "";
  const localeMap = { TRY: "tr-TR", USD: "en-US", EUR: "de-DE" };
  const formatted = new Intl.NumberFormat(localeMap[currency] || "tr-TR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
  if (currency === "TRY") return `${formatted} ${symbol}`;
  return `${symbol}${formatted}`;
}

export function formatDate(dateStr) {
  if (!dateStr) return "";
  const d = typeof dateStr === "string" ? new Date(dateStr) : dateStr;
  return new Intl.DateTimeFormat("tr-TR", { year: "numeric", month: "short", day: "2-digit" }).format(d);
}

export function daysUntil(dateStr) {
  const target = new Date(dateStr);
  const now = new Date();
  target.setHours(0, 0, 0, 0);
  now.setHours(0, 0, 0, 0);
  return Math.round((target - now) / (1000 * 60 * 60 * 24));
}

export function toISODate(date) {
  const d = new Date(date);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}
